import { toError } from '../tpa/common/error';
import { hasPhone } from './has-phone';
import { hasMultilineAddress } from './has-multiline-address';
import { hasPaymentField } from './has-payment-fields';
export const loadTranslations = importWithFallback(importTranslations);
export const loadTPATranslations = importWithFallback(importTPATranslations);
const COUNTRY_KEYS_PREFIX = ['locale-dataset.countries'];
const ADDRESS_KEYS_PREFIX = [
    'locale-dataset.states',
    'locale-dataset.subdivisions',
    'locale-dataset.addressParts',
];
const CURRENCY_KEYS_PREFIX = ['locale-dataset.currencies'];
export const defaultLocaleDatasetLoader = (forms, locale, errorMonitor) => {
    const _hasPhone = forms.some(hasPhone);
    const _hasMultilineAddress = forms.some((f) => hasMultilineAddress(f));
    const _hasPaymentField = forms.some(hasPaymentField);
    return () => loadLocaleDataset({
        locale,
        errorMonitor,
        loadCountryKeys: _hasPhone || _hasMultilineAddress,
        loadAddressKeys: _hasMultilineAddress,
        loadCurrencyKeys: _hasPaymentField,
    });
};
const loadLocaleDataset = async ({ locale, errorMonitor, loadCountryKeys = false, loadAddressKeys = false, loadCurrencyKeys = false, }) => {
    if (!loadCountryKeys && !loadAddressKeys) {
        return {};
    }
    const localeDataset = await importWithFallback(importLocaleDataset)(locale, errorMonitor);
    const filteredDataset = {};
    for (const key in localeDataset) {
        if (loadAddressKeys &&
            ADDRESS_KEYS_PREFIX.some((prefix) => key.startsWith(prefix))) {
            filteredDataset[key] = localeDataset[key];
        }
        if (loadCountryKeys &&
            COUNTRY_KEYS_PREFIX.some((prefix) => key.startsWith(prefix))) {
            filteredDataset[key] = localeDataset[key];
        }
        if (loadCurrencyKeys &&
            CURRENCY_KEYS_PREFIX.some((prefix) => key.startsWith(prefix))) {
            filteredDataset[key] = localeDataset[key];
        }
    }
    return filteredDataset;
};
async function importTranslations(locale) {
    const messages = await import(
    /* webpackChunkName: "form-viewer-[request]" */ `../assets/locale/messages_${locale}.json`);
    const fieldMessages = await import(
    /* webpackChunkName: "form-fields-viewer-[request]" */ `@wix/form-fields/dist/esm/assets/locale/viewer/messages_${locale}.json`);
    return { ...messages.default, ...fieldMessages.default };
}
async function importTPATranslations(locale) {
    const messages = await import(
    /* webpackChunkName: "tpa-[request]" */ `../assets/locale/messages-tpa_${locale}.json`);
    return messages.default;
}
async function importLocaleDataset(locale) {
    const messages = await import(
    /* webpackChunkName: "locale-dataset-[request]" */ `@wix/locale-dataset-data/resources/translations/messages_${locale}.json`);
    return messages.default;
}
function importWithFallback(importMessages) {
    return async (locale, errorMonitor) => {
        try {
            const messages = await importMessages(locale);
            return messages;
        }
        catch (_error1) {
            try {
                const messages = await importMessages('en');
                errorMonitor?.captureException(toError(_error1));
                return messages;
            }
            catch (_error2) {
                const empty = {};
                errorMonitor?.captureException(toError(_error2));
                return empty;
            }
        }
    };
}
//# sourceMappingURL=load-translations.js.map